import { render, staticRenderFns } from "./ProfilInfo.vue?vue&type=template&id=25c2ced8&"
import script from "./ProfilInfo.vue?vue&type=script&lang=js&"
export * from "./ProfilInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports